import { required, url } from 'vuelidate/lib/validators'

import { vattenfallUrl } from '@/validators/customValidators'

export const documentModel = {
  form: {
    url: {
      required,
      url,
      vattenfallUrl
    },
    name: {
      required
    }
  }
}
